import { render } from "./FireExtinguisher.vue?vue&type=template&id=8e2e298c&lang=html"
import script from "./FireExtinguisher.vue?vue&type=script&setup=true&lang=js"
export * from "./FireExtinguisher.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__